import { getShippingWeightUnits } from './api';

export const SHIPPING_WEIGHT_UNITS = {
  cacheKey: 'SHIPPING_WEIGHT_UNITS',
  apiFunction: getShippingWeightUnits
};
